import {SignUpComponent} from "../SignUpComponent.js";
import {isWebView} from "../../store.js";
import {imageSliderJsonArrayA, imageSliderJsonArrayB} from "./SignUpCarouselJson.js";


export class Layout extends SignUpComponent {

    template() {
        const {sectionId = ''} = this.$props;
        return `
                <section id="${sectionId}" class="signup-wide-pop">
                    <header class="js-section-header"></header>
                    <article>
                        <div class="pop-main js-contents-main">
                            ${this.getMainTextTemplate()}
                            ${this.getSubTextTemplate()}
                            ${this.getNexPageButtonTemplate()}
                        </div>
                    </article>
                </section>`
    }

    getMainTextTemplate() {
        const {mainText = ''} = this.$props;
        return  !Mutil.empty(mainText) ?  `<h3 id="mainTxt">${mainText}</h3>` : "";
    }

    getSubTextTemplate() {
        const { subText = ''} = this.$props;
        return  !Mutil.empty(subText) ?  `<p id="subTxt">${subText}</p>` : "";
    }

    getNexPageButtonTemplate() {
        const {nextButton = {}} = this.$props;

        if(Object.values(nextButton).length === 0) {
            return ``
        }

        return  `<button id = "${nextButton.id}" class="js-next-page-button btn-next">${Mutil.n2v(nextButton.text)}</button>`;
    }

    getNextLinkTemplate() {
        const {nextLink = {}} = this.$props;
        if(Object.values(nextLink).length === 0) {
            return ``
        }

        const {
            id = "",
            text = "" ,
            isBottom = false,
            isView = true,
        } = nextLink;

        if(!isView) {
            return ''
        }

        if(Often.isGlobal()) return '';
        return   `<a id = "${Mutil.n2v(id)}" class="js-next-page-link ${isBottom ? "sign-bottom-link" : "" }" > ${Mutil.n2v(text)}</a>`;
    }

    setEvent() {
        this.setNextPageButtonEvent();
        this.setNextPageLinkEvent();
    }

    setNextPageLinkEvent() {
        const {nextLink = {}} = this.$props;
        if (Object.values(nextLink).length === 0) {
            return;
        }
        const {
            nextPageFunc = Mutil.noop
        } = nextLink;
        this.addEvent("click.prevent", ".js-next-page-link", () => {
            nextPageFunc();
        });
    }

    setNextPageButtonEvent() {
        const {nextButton = {}} = this.$props;
        if (Object.values(nextButton).length === 0) {
            return;
        }

        const {
            nextPageFunc = Mutil.noop
        } = nextButton;

        const _nextPageFunc = new Mutil.DebounceNThrottle(() => {
            nextPageFunc()
        }, 300);
        this.addEvent("click", '.js-next-page-button', (e) => {
            _nextPageFunc.debounceAfterStart();
        });
    }

    getHeaderSelector() {
        return ".js-section-header"
    }

    getHeaderLayer() {
        return $(this.getSelectionSelector()).find(`${this.getHeaderSelector()}`)
    }

    getSelectionSelector() {
        const {sectionId = ''} = this.$props;
        return Mutil.empty(sectionId) ? "section" : `#${sectionId}`;
    }

    getMainArticle() {
        return $(this.getSelectionSelector()).find(`article`);
    }
    getMainLayer() {
        return $(this.getSelectionSelector()).find(`.js-contents-main`);

    }
    getSubTextLayer() {
        return $('#subTxt')
    }

    getPolicyBottomTemplate() {
        const policy = `<a href="/terms.act" target="${isWebView() ? "_self" : "_blank" }">${i18next.t(login.srvcetrms)}</a>, <a href="/privacy.act" target="${isWebView() ? "_self" : "_blank" }">${i18next.t(login.pvcyplcy)}</a>`;
        const Internationalization = Mutil.requireIIFE("Internationalization");
        if(Internationalization.getCurrentLanguage().toLowerCase().includes("en")) {
            return `By signing up, you agree to our ` + policy + ". <br />You also agree to receive product related emails."
        }

        if(Internationalization.getCurrentLanguage().toLowerCase() === 'ko' || Internationalization.getCurrentLanguage().toLowerCase()  === 'ja') {
            return policy + `${i18next.t(login.agreepvcy)}`;
        }

        return `${i18next.t(login.agreepvcy)}` + policy;
    }
}
